/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";


//get all plate list
const getAreaList = async (page :number, size :number, sort :string, order : string, keyWord:any, type:string, parent_area: string = "", gradeId?: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active,inactive&keyword=${keyWord}&type=${type}&parent_area=${parent_area}&grade_id=${gradeId || ""}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};

//get all active area list
const getActiveAreaList = async (page :number, size :number, sort :string, order : string, keyWord:any, type:string, parent_area: string = "", gradeId?: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&keyword=${keyWord}&type=${type}&parent_area=${parent_area}&grade_id=${gradeId || ""}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};

const getAreaByScan = async (
  id: any,
  location_type: any,
) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/scan/location` ,{
      id: id,
      area_location_code: location_type,
      expected_location_types: "12,9,8"
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const listAreaType= async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=&size=&sort=id&order=asc&status=active&keyword=&type=8,6,17`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getLocationPolicy = async (page :number, size :number, sort :string, order : string, keyWord:any, location_type:string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/policies/list?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active,inactive&keyword=${keyWord}&location_type=${location_type}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};

const getLocationStatus = (status: number): string => {
  switch (status) {
    case 1:
      return "PLANT";
    case 2:
      return "UNIT";
    case 3:
      return "BUILDING / BLOCK";
    case 4:
      return "LINE";
    case 5:
      return "AREA";
    case 6:
      return "PRODUCTION AREA";
    case 7:
      return "INCUBATION AREA";
    case 8:
      return "LAB AREA";
    case 9:
      return "AUTOCLAVE AREA";
    case 10:
      return "Personnel Monitoring ";
    case 11:
      return "ACTIVE AIR SAMPLING";
    case 12:
      return "INCUBATOR";
    case 13:
      return "Contact Plate Monitoring";
    case 14:
      return "PLATE ISSUE AREA";
    case 15:
      return "PASSIVE AIR SAMPLING";
    case 17:
      return "CHANGING ROOM AREA"
    default:
      return "UNKNOWN STATUS";
  }
};

const changePolicyStatus = async (policy_id: string, status: string , interface_name : string) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/policies/change_status`, {
      id: policy_id,
      status: status,
      interface_name: interface_name
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getSchedulePolicy = async (page :number, size :number, sort :string, order : string, keyWord:any, location_type:number) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/schedules/list?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active,inactive&keyword=${keyWord}&location_type=${location_type}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};

const changeScheduleStatus = async (id: string, status: string, interface_name : string) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/schedules/change_status`, {
      id: id,
      status: status,
      interface_name : interface_name
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getParentAreaList = async ( type?:number[],parent_area?: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=&size=&sort=&order=asc&status=active,inactive&keyword=&type=${type}&parent_area=${parent_area}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};
const getLocationList = async ( type?:number[],parent_area?: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=&size=&sort=&order=asc&status=active,inactive&keyword=&type=${type}&parent_area=`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};
const getParentAreaLists = async ( type?:number[]) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=&size=&sort=&order=asc&status=active,inactive&keyword=&type=${type}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};


const getParentlocationsList = async ( type:number[], equipment: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_unassigned_locations_for_equipments?type=${type}&equipment_id=${equipment}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};

const getPolicyNameList = async ( type:number) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/policies/list?sort=id&order=asc&status=active&keyword&location_type=${type}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};

const createArea = async (dataToSend:any) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/location/create`, 
     dataToSend,
     {
       headers: {
         'x-auth-token': authToken,
         'x-userid': authUserID
       }
     }
    );
    return response.data;
  }catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
}
}

const getExposurePointList = async (parent: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=1&size=10&sort=id&order=asc&status=active&keyword=&type=11&parent_area=${parent}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    return error;
  }
}

const getAreaId = async (Id:string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/get_details_by_id?id=${Id}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const changeAreaStatus = async (area_id: string, status: string, interface_name : string) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/location/change_status`, {
      id: area_id,
      status: status,
      interface_name : interface_name
    },{
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getAddAreaType= async (type : string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=1&size=10&sort=id&order=asc&status=active&keyword=&type=${type}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const geAreaDropDownList = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_all_location_types?status=active&category=0&type_code=6,8,17`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const geAreaDropDownPolicyList = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_all_location_types?status=active&category=0&type_code=6,8,9,12`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const geLocationDropDownList = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_all_location_types?status=active&category=1&type_code=13,18,11,15,19`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getAreaDropDownList = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_all_location_types?status=active&category=1&type_code=13,18,11,15,19,20,21,22`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getIncidentFilter = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_all_location_types?status=active&type_code=8,9,10,11,12,13,15,31,19,20,21,22`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getHeirarchyType= async (type : string, parent_area: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=1&size=100&sort=id&order=asc&status=active&keyword=&type=${type}&parent_area=${parent_area}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}
const getHeirarchyTypes= async (type : string, parent_area: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=1&size=&sort=id&order=asc&status=active&keyword=&type=${type}&parent_area=${parent_area}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getLocationPointList = async (parent: string) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all?page=1&size=10&sort=id&order=asc&status=active&keyword=&type=10,11,13,15&parent_area=${parent}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    return error;
  }
}

const getIncubatorList = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_area_equipments?sort=id&order=asc&status=active&keyword=&type=12&parent_area=`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}

const getPlateGradeList = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/master/list_all_plate_grades?status=active`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
};

const getAreaCategoryList = async (grade_id ?: any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/area_category/list_all_area_category?&sort=id&status=active,inactive&order=asc&id=&grade_id=${grade_id || ""}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
}

const getLocationByActivity = async (id:any, areaGrade?: any, locationCategory?: any, areaId?: any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all_locations_by_activity?&sort=id&order=asc&activity_id=${id}&area_grade=${areaGrade || ""}&location_category=${locationCategory || ""}&area_id=${areaId || ""}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}
const getLocationByActivities = async (id:any, areaGrade?: any, locationCategory?: any, areaId?: any) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/location/list_all_locations_by_activity?&sort=id&order=asc&area_status=active&activity_id=${id}&area_grade=${areaGrade || ""}&location_category=${locationCategory || ""}&area_id=${areaId || ""}`,
    {
      headers: {
        'x-auth-token': authToken,
        'x-userid': authUserID
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data
    }
  }
}



const areaService = {
  getAreaList,
  getActiveAreaList,
  // getAreaStatus,
  getAreaByScan,
  listAreaType,
  getLocationPolicy,
  getLocationStatus,
  changePolicyStatus,
  getSchedulePolicy,
  changeScheduleStatus,
  getParentAreaList,
  getPolicyNameList,
  createArea,
  getExposurePointList,
  getAreaId,
  changeAreaStatus,
  getAddAreaType,
  geAreaDropDownList,
  getHeirarchyType,
  geLocationDropDownList,
  getLocationPointList,
  getIncubatorList,
  getPlateGradeList,
  getAreaCategoryList,
  geAreaDropDownPolicyList,
  getIncidentFilter,
  getLocationByActivity,
  getLocationByActivities,
  getAreaDropDownList,
  getParentlocationsList,
  getParentAreaLists,
  getHeirarchyTypes,
  getLocationList
};

export { areaService };
